/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { split } from "lodash";

import { DeviceTypeEnum, DeviceTypeMapper, GroupByEnum, GroupByMapper } from "~/features/reportTracker/constants";
import { ReportDetails } from "~/features/reportTracker/types";
import { StatisticsGroupBy, StatisticsPlatform } from "~/features/statistics/constants";
import { FilterOptions } from "~/features/statistics/types";

const mapReportParamsToStatisticsFilter = (data: ReportDetails, sitesByName: { [p: string]: number }) => {
  const mappedDevice = DeviceTypeMapper[data.params.device as DeviceTypeEnum];
  const mappedGroupBy = GroupByMapper[data.params.groupBy as GroupByEnum];

  const selectedSiteIds = Object.entries(sitesByName)
    .filter(([key]) => !data.params.excludedSites.includes(key))
    .map((key) => Number(sitesByName[key[0]]));

  return {
    from: split(data.params.from, " ")[0],
    to: split(data.params.to, " ")[0],
    selectedSiteIds,
    trkid: data.params.trackingId ?? "",
    dev: StatisticsPlatform[mappedDevice] ?? "",
    groupBy: StatisticsGroupBy[mappedGroupBy],
    lastPayouts: data.params.lastPayouts ?? undefined,
  } as FilterOptions;
};

export default mapReportParamsToStatisticsFilter;
